import { createUseStyles } from 'react-jss';
import { SpacingsValues } from '@picsart/cascade';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      paddingBlock: SpacingsValues.s32,
      maxWidth: 'min(100%, var(--max-width-02))',
      marginInline: 'auto',

      '& .brk': {
        display: 'block',
      },
      [mediaQuery(breakpoints.tablet)]: {
        '& .brk': {
          display: 'inline',
        },
      },
    },

    lst: {
      listStyleType: 'none',
      flexWrap: 'wrap',
      gap: 24,
      marginInline: 172,

      [mediaQuery(breakpoints.largeDesktop)]: {
        marginInline: 24,
      },

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
      },
    },

    container: {
      display: 'grid',
      gridTemplateColumns: '48px 1fr',
      width: 256,

      [mediaQuery(breakpoints.tablet)]: {
        maxWidth: 'calc(100% - 48px)',
        marginRight: 0,

        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },

    iconContainer: {
      borderRadius: '50%',
      boxShadow: '0px 2px 8px rgba(17, 18, 54, 0.16)',
      marginRight: SpacingsValues.s8,
      width: 48,
      height: 48,

      '&:last-child': {
        marginRight: 0,
      },
    },

    icon: {
      fill: 'var(--x-black-1)',
      height: 24,
      width: 24,
    },

    text: {
      color: 'var(--x-black-1)',
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '28px',
      marginLeft: SpacingsValues.s16,
    },
  }),
  {
    name: 'TagLines',
  },
);

export default useStyles;
